export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";

export const PROMOTION_DATE_FORMAT = "YY.MM.DD HH:mm";

export const GLOBAL_DATE_FORMATS = {
	DATE_TIME_WITH_DASH: "YYYY-MM-DD HH:mm",
	DATE_TIME_WITH_DOT: "YYYY.MM.DD HH:mm",
	DATE: "YYYY.MM.DD",
	TIME: "HH:mm",
	LOCALE: "L"
};
